<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="单位名称">
              <a-input v-model="queryParam.keywords" placeholder="搜索单位名称"/>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择考试状态"
                        allowClear >
                <a-select-option value="1">等待审核</a-select-option>
                <a-select-option value="2">审核成功</a-select-option>
                <a-select-option value="3">审核失败</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="调用次数">
                <a-input-number v-model="queryParam.callNo" style="width: 100%"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="更新日期">
                <a-date-picker v-model="queryParam.date" style="width: 100%" placeholder="请输入更新日期"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select v-model="queryParam.useStatus" placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="使用状态">
                <a-select placeholder="请选择" default-value="0">
                  <a-select-option value="0">全部</a-select-option>
                  <a-select-option value="1">关闭</a-select-option>
                  <a-select-option value="2">运行中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">

    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="name" slot-scope="name,record">
         {{record.name}}<br/>
        {{record.danwei}}
      </span>
      <span slot="address" slot-scope="name,record">
        {{record.datetitle}}<br/>{{record.address}}
      </span>
      <span slot="kaoguan" slot-scope="text,record">
        考官:
        <span v-if="record.kaoguan.length>0">
          <a-tag v-for="user in record.kaoguan">{{user.name}}({{user.grade}}) {{user.phone}}</a-tag>
        </span>
        <span v-else>无</span>
            <br/>
        监督:
        <span v-if="record.jiandu.length>0">
          <a-tag v-for="user in record.jiandu">{{user.name}} {{user.phone}}</a-tag>
        </span>
        <span v-else>无</span>

      </span>
      <span slot="group" slot-scope="name,record">
        {{record.seller_group_name}}<br/>
        ({{record.score1}})
      </span>
      <span slot="status" slot-scope="text,record">
            <a-badge status="error" v-if="record.status==1" text="等待审核" />
            <a-badge status="success" v-else-if="record.status==2" text="审核成功" />
            <a-badge status="default" v-else text="审核失败" />
      </span>

      <span slot="action" slot-scope="text, record">
        <template >
          <a v-if="record.status==2" @click="handleMingdanManage(record)">出场顺序</a>
        </template>
        <span v-if="record.added==true&&(record.score_status==1||record.score_status==2)" >
          <a-divider type="vertical" />
          <a @click="handleStep1Manage(record)">预评分</a>
        </span>
        <span v-show="record.added==true&&(record.score_status==2||record.score_status==3||record.score_status==4)" >
          <a-divider type="vertical" />
          <a @click="handleStep2Manage(record)">正式打分</a>
        </span>

      </span>
    </s-table>

    <a-modal
            title="出场顺序"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="mingdanVisible"
            @ok="mingdanSave"
    >
      <a-spin :spinning="saveLoading">
        <a-transfer
                :dataSource="mingdanList"
                showSearch
                :listStyle="{
                width: '350px',
              }"
                :filterOption="mingdanFilterOption"
                :targetKeys="mingdanTargetKeys"
                @change="mingdanHandleChange"
                @selectChange="mingdanHandleSelectChange"
                @search="mingdanHandleSearch"
                :render="renderItem"
        >
          <div
                  slot="footer"
                  class="footer-btn"
                  slot-scope="props">
            <a-button

                    size="small"
                    style="margin: 5px"
                    @click="mingdanUp"
            >
              上移
            </a-button>
            <a-button
                    size="small"
                    style="margin: 5px"
                    @click="mingdanDown"
            >
              下移
            </a-button>

          </div>
        </a-transfer>
      </a-spin>
    </a-modal>


    <a-modal
            title="预评分管理"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="scoreStep1Visible"
            @ok="score1Save"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">

            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="考官"
                      hasFeedback
              >
                <div v-for="(user,index) in scoreList1.exame.kaoguan" :key="index" >
                  <span >{{user.name}}{{user.phone}}<br/>({{user.num}})</span>
                  <a-icon type="close-circle" @click="kaoguanRemove(index)" />
                </div>

                <a @click="kaoguanPickerShow = true" v-show="!kaoguanPickerShow" v-if="scoreList1.exame.kaoguan.length<4" href="#nogo">新增</a>
                <kaoguan-picker style="width: 300px; margin-right: 10px;"   @onSelect="onKaoguanAdd" v-show="kaoguanPickerShow" />
                <a @click="kaoguanPickerShow = false" v-show="kaoguanPickerShow" href="#nogo">取消</a>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                      :labelCol="labelCol"
                      :wrapperCol="wrapperCol"
                      label="监督"
                      hasFeedback
              >
                <div v-for="(user,index) in scoreList1.exame.jiandu" :key="index" >
                  <span >{{user.name}}{{user.phone}}<br/>({{user.num}})</span>
                  <a-icon type="close-circle" @click="jianduRemove(index)" />
                </div>

                <a @click="jianduPickerShow = true" v-show="!jianduPickerShow" v-if="scoreList1.exame.jiandu.length==0" href="#nogo">新增</a>
                <jiandu-picker style="width: 300px; margin-right: 10px;"  @onSelect="onJianduAdd" v-show="jianduPickerShow" />
                <a @click="jianduPickerShow = false" v-show="jianduPickerShow" href="#nogo">取消</a>
              </a-form-item>
            </a-col>

          </a-row>

          <a-form-item
                  label="品德附件"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  extra="请上传相关附件"
          >
            <file-uploader
                    :file-list="scoreList1.exame.gongyi_files"
            />
          </a-form-item>

          <a-table :columns="step1Columns" :dataSource="scoreList1.list" :pagination="false" rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="userQuery.keywords"
                      placeholder="搜索姓名"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="customerSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="customerSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="name,record">
              {{record.name}} - {{record.grade}}<br/>
              {{record.num}}
            </span>
            <span slot="peixun" slot-scope="name,record">
              <a-input v-model="record.score_peixun" />
            </span>
            <span slot="gongyi" slot-scope="name,record">
              <a-input v-model="record.score_gongyi" />
            </span>
            <template slot="customPeixun">
              <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllScorePeixun">
                <span slot="icon" />
                <template slot="title">
                  <a-input v-model="allScorePeixun"
                              placeholder="批量设置分数"/>
                </template>
                培训课时分 <a-icon type="form" />
              </a-popconfirm>
            </template>
            <template slot="customGongyi">
              <a-popconfirm okText="确定" cancelText="取消" @confirm="setAllScoreGongyi">
                <span slot="icon" />
                <template slot="title">
                  <a-input v-model="allScoreGongyi"
                              placeholder="批量设置分数"/>
                </template>
                品德 <a-icon type="form" />
              </a-popconfirm>
            </template>


          </a-table>
        </a-form>
      </a-spin>
    </a-modal>



    <a-modal
            title="评分管理"
            :width="1300"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'600px','overflowY':'scroll'}"
            v-model="scoreStep2Visible"
    >
      <a-spin :spinning="saveLoading">
        <a-form  layout="inline" >
          <a-form-item
                  v-for="(kaoguan,index) in scoreList2.exame.kaoguan"
                  :key="index"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  :label="'考官'+(index+1)"
                  hasFeedback
          >
            <a-input readonly v-model='scoreList2.exame.kaoguan[index]' placeholder="请输入考官姓名"/>
            <a-icon
                    v-show="index>1"
                    class="dynamic-delete-button"
                    type="minus-circle-o"
                    style="position: absolute;  right: -23px;  top: 3px;"
                    @click="() => removeKaoguan(index)"
            />
          </a-form-item>
          <!--<a-button v-show="scoreList2.exame.kaoguan.length<4"-->
                  <!--type="dashed"-->
                  <!--@click="addKaoguan"-->
          <!--&gt;-->
            <!--<a-icon type="plus" /> 增加考官-->
          <!--</a-button>-->
          </a-form>
        <a-form  layout="inline" >
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="监督"
                  hasFeedback
          >
            <a-input readonly v-model="scoreList2.exame.jiandu[0]" placeholder="请输入监督姓名"/>
          </a-form-item>
        </a-form>
          <a-table :columns="step2Columns" :dataSource="scoreList2.list" :pagination="false" rowKey="id" :scroll="{x:'100%', y: 400 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="userQuery.keywords"
                      placeholder="搜索姓名"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="customerSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="customerSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="name" slot-scope="name,record,index">
             {{index+1}}# {{record.name}} - {{record.grade}}<br/>
              {{record.num}}
              <a v-if="scoreList2.apply.score_status==4" @click="downloadCert(record)" href="#nogo">电子证书</a>
                <a-divider type="vertical" />
              <a v-if="scoreList2.apply.score_status==4" @click="downloadCertP(record)" href="#nogo">证书下载</a>
            </span>
            <div slot="score_fanteng" slot-scope="name,record,index">
            <div
                    v-for="(kaoguan,index) in scoreList2.exame.kaoguan"
                    :key="index"
            >
              <a-input :placeholder="'考官'+(index+1)" :disabled="record.huankao==1 || operateDisabled" style="width: 100px" v-model="record['score_fanteng'+(index+1)]"  />
            </div>
              </div>

            <div slot="score_zhuanti" slot-scope="name,record,index">
              <div
                      v-for="(kaoguan,index) in scoreList2.exame.kaoguan"
                      :key="index"
              >
                <a-input :placeholder="'考官'+(index+1)" :disabled="record.huankao==1 || operateDisabled" style="width: 100px" v-model="record['score_zhuanti'+(index+1)]"  />
              </div>
            </div>

            <div slot="score_tiaoyue" slot-scope="name,record,index">
              <div
                      v-for="(kaoguan,index) in scoreList2.exame.kaoguan"
                      :key="index"
              >
                <a-input :placeholder="'考官'+(index+1)" :disabled="record.huankao==1 || operateDisabled" style="width: 100px" v-model="record['score_tiaoyue'+(index+1)]"  />
              </div>
            </div>

            <div slot="score_pingheng" slot-scope="name,record,index">
              <div
                      v-for="(kaoguan,index) in scoreList2.exame.kaoguan"
                      :key="index"
              >
                <a-input :placeholder="'考官'+(index+1)" :disabled="record.huankao==1 || operateDisabled" style="width: 100px" v-model="record['score_pingheng'+(index+1)]"  />
              </div>
            </div>

            <div slot="score_liliang" slot-scope="name,record,index">
              <div
                      v-for="(kaoguan,index) in scoreList2.exame.kaoguan"
                      :key="index"
              >
                <a-input :placeholder="'考官'+(index+1)" :disabled="record.huankao==1 || operateDisabled" style="width: 100px" v-model="record['score_liliang'+(index+1)]"  />
              </div>
            </div>


            <div slot="score_dongzuo" slot-scope="name,record,index">
              <div
                      v-for="(kaoguan,index) in scoreList2.exame.kaoguan"
                      :key="index"
              >
                <a-input :placeholder="'考官'+(index+1)"  :disabled="record.huankao==1 || operateDisabled" style="width: 100px" v-model="record['score_dongzuo'+(index+1)]"  />
              </div>
            </div>


            <span slot="huankao" slot-scope="huankao,record">
              <r-switch  :formData="record" field="huankao" :checkedValue="1" :unCheckedValue="2" checkedChildren="缓考" unCheckedChildren="否" :disabled="operateDisabled" />
            </span>
          </a-table>
      </a-spin>


      <template slot="footer">
        <a-popconfirm  title="是否确认分数吗?" okText="确定" cancelText="取消" @confirm="setScoreStatus(4)" v-if="scoreList2.apply.score_status == 3">
          <a-button type="primary">确认分数</a-button>
        </a-popconfirm>
<!--        <a-button key="upload" v-if="scoreList2.apply.score_status==2" @click="resultConfirm">成绩一键上传</a-button>-->
        <a-button key="downloadTemplate" v-if="scoreList2.apply.score_status==2" @click="resultConfirm">成绩一键上传模板下载</a-button>
        <a-upload
            v-if="scoreList2.apply.score_status==2"
            :fileList="[]"
            accept=".xls,.xlsx"
            :customRequest="readFile"
            style="display: inline-block;margin:0 8px;"
        >
          <a-button>成绩一键上传</a-button>
        </a-upload>
        <a-button key="share"  @click="onShare" >分享考官监督</a-button>
        <a-button key="download" @click="downloadResults(exame_id)">导出成绩单</a-button>
        <a-button key="createAll" v-if="scoreList2.apply.score_status==4" @click="downloadAllShow = true">批量下载证书</a-button>
        <r-switch @change="onCertFaceChange" v-if="scoreList2.apply.score_status==4"  :formData="scoreList2.exame" field="cert_with_face" :checkedValue="1" :unCheckedValue="2" checkedChildren="证书带照片" unCheckedChildren="证书不带照片" />
        <a-button key="forward" v-if="scoreList2.apply.score_status==2" :loading="saveLoading" type="primary" @click="score2Save">保存</a-button>
      </template>
    </a-modal>

    <a-modal title="分享给考官监督" v-model="h5ShareVisible" @ok="h5ShareVisible=false">
      <p style="text-align: center">
        <img :src="share.h5_pic_url" />
      </p>
      <p style="text-align: center">将二维码分享给考官监督进行评分</p>
    </a-modal>


      <a-modal
              :maskClosable="false"
              :footer="null"
              title="批量生成"
              v-model="downloadAllShow"
      >
          <p v-show="taskInfo.doing">正在批量生成证书,请勿关闭或者刷新页面 <br/>
              <a-badge status="success"   :text="'成功 '+(taskInfo.scount)" /><a-divider type="vertical" />
              <a-badge status="error"   :text="'失败 '+(taskInfo.fcount)" /> <a-divider type="vertical" />
              <a-badge status="processing"   :text="'总数 '+(taskInfo.urls.length-1) " /> </p>
          <p  v-show="!taskInfo.doing && scoreList2.exame.cert_zip">
              <a @click="createAllCert(exame_id)">重新生成</a>
              <a-divider type="vertical" />
              <a @click="downloadCertSP()">批量下载</a>
          </p>
          <p  v-show="!taskInfo.doing && !scoreList2.exame.cert_zip">
              <a @click="createAllCert(exame_id)">批量生成</a>
          </p>
          <p><a-progress  v-show="taskInfo.doing" :percent="taskInfo.percent" /></p>
      </a-modal>

    <a-modal
        :maskClosable="false"
        title="错误信息"
        :width="600"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="showError"
    >
      <div v-for="item in errorMsg">{{item}}</div>
      <template slot="footer">
        <a-button key="cancel" @click="showError = false">取消</a-button>
      </template>
    </a-modal>
    <a-modal
        :maskClosable="false"
        title="批量上传"
        :width="600"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="showLoading"
    >
      <template>
        <div style="text-align: center">
          <a-progress type="circle" :percent="progress" />
        </div>
      </template>
      <template slot="footer">
        <a-button key="cancel" @click="showLoading = false">取消</a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
  import XLSX from "xlsx";
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import moment from 'moment'
  import UserPicker from '@/components/UserPicker/'
  import FileUploader from '@/components/FileUploader/'
  import KaoguanPicker from '@/components/KaoguanPicker/'
  import JianduPicker from '@/components/JianduPicker/'
  import RSwitch from '@/components/RSwitch/'
  import setting from '@/config/setting'

  import { editApplyScoreStatus} from '@/api/qcxj'
  import { doUrlTask } from '@/api/utils'
  import { getKaojiList,getKaojiYundongyuanList ,mingdanSave,getScore1List ,score1Save,getScore2List ,score2Save,scoreConfirm ,getAllCertUrls,setCertFace,scoreMemberAdd} from '@/api/kaojiexame'

  export default {
    name: 'KaojiList',
    components: {
      AInput,
      ATextarea,
      STable,
      UserPicker,
      FileUploader,
      RSwitch,
      KaoguanPicker,
      JianduPicker,
    },
    data () {
      return {
        exame_id :0,
        mingdanList:[
        ],
        mingdanTargetKeys:[],
        selectedMingdanKeys:[],
        kaoguanPickerShow: false,
        h5ShareVisible: false,
        jianduPickerShow: false,
        mingdanVisible: false,
        scoreStep1Visible: false,
          downloadAllShow: false,
        scoreStep2Visible: false,
        share:{
          h5_pic_url:''
        },
        scoreList1:{
          exame:{
            kaoguan:[],
            jiandu:[],
            gongyi_files:[]
          },
          list:[]
        },
        scoreList2:{
          exame:{
            kaoguan:[],
            jiandu:[],
            cert_with_face:1
          },
          list:[],
          apply:{}
        },
        saveLoading:false,
//        description: '全校班级管理。',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
        },
        groupOptions:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            sorter: true
          },
          {
            title: '用户名/单位',
            dataIndex: 'name',
            scopedSlots: { customRender: 'name' },
          },
          {
            title: '考试时间/地点',
            dataIndex: 'address',
            scopedSlots: { customRender: 'address' },
          },
          {
            title: '考官/监督',
            dataIndex: 'kaoguan',
            scopedSlots: { customRender: 'kaoguan' },
            width: 200
          },
          {
            title: '申请时间',
            dataIndex: 'create_time',
            customRender: (text) =>  {
              return moment(text*1000).format('YYYY-MM-DD HH:mm:ss');
            }
          },
          {
            title: '状态',
            dataIndex: 'status',
            scopedSlots: { customRender: 'status' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '170px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        userQuery:{

        },
        //人员管理表头
        step1Columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '运动员姓名',
            dataIndex: 'name',
            width:'250px',
            scopedSlots: {
//              filterDropdown: 'filterDropdown',
//              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '参与赛事',
            width:'150px',
            dataIndex: 'score_sai',
            slots: { title: 'customSai' },
          },
          {
            width:'150px',
            dataIndex: 'score_peixun',
            scopedSlots: { customRender: 'peixun' },
            slots: { title: 'customPeixun' },
          },
          {
            dataIndex: 'score_gongyi',
            scopedSlots: { customRender: 'gongyi' },
            slots: { title: 'customGongyi' },
          },
        ],
        //表头2
        step2Columns:[],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam.seller_group_ids = [];
          if(parameter.seller_group_name && parameter.seller_group_name.length){
            this.queryParam.seller_group_ids =  parameter.seller_group_name;
          }
          this.queryParam = Object.assign( this.queryParam,parameter);
          return getKaojiList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
        },

        progress:0,
        startNum: 1,
        errorMsg: [],
        showLoading: false,
        showError: false,
        operateDisabled: true,
        allScorePeixun:undefined,
        allScoreGongyi:undefined,
        selectedRowKeys: [],
        selectedRows: [],
          taskInfo :{
          urls: [],
          currentIndex:0,
          scount:0,
          fcount:0,
              percent:0,
          doing:false,
        }
      }
    },

    watch: {
      'scoreList2.list': {
        handler(newValue, oldValue) {
          this.scoreCompute();
        },
        deep: true
      },
      'scoreList2.exame.kaoguan': {
        handler(newValue, oldValue) {
          this.scoreCompute();
          this.columnsCompute();
        },
        deep: true
      },
    },
    computed:{
    },
    created () {
//      getRoleList({ t: new Date()})
    },
    mounted(){
    let self = this;
    },
    methods: {
      renderItem(item){
        const customLabel = (
                  <span class="custom-item">
                {item.id} {item.title} - {item.description}
        </span>
        );
          return {
            label: customLabel, // for displayed item
            value: item.title, // for title and filter matching
          };
      },
      mingdanUp(){
        let that = this;
        if(that.selectedMingdanKeys.length==0){
          return ;
        }
        if(that.mingdanTargetKeys.length==0){
          return ;
        }
        console.log(that.mingdanTargetKeys);
//        that.mingdanTargetKeys.pop();
        var list = [...that.mingdanTargetKeys];
        that.selectedMingdanKeys.map(sitem =>{
          that.mingdanTargetKeys.map((titem,index) =>{
            if(titem == sitem){
              if(index ==0 ){
                //第一个
                return;
              }
              var temp = list[index];
//              that.$set(this.mingdanTargetKeys,index,that.mingdanTargetKeys[index-1]);
//              that.$set(this.mingdanTargetKeys,index-1,temp);

              list[index] = list[index-1];
              list[index-1] = temp;

            }
          })

        });

        that.mingdanTargetKeys = [...list];

      },
      mingdanDown(){
        let that = this;

        if(that.selectedMingdanKeys.length==0){
          return ;
        }
        if(that.mingdanTargetKeys.length==0){
          return ;
        }
        console.log(that.mingdanTargetKeys);
//        that.mingdanTargetKeys.pop();
        var list = [...that.mingdanTargetKeys];
        that.selectedMingdanKeys.map(sitem =>{
          that.mingdanTargetKeys.map((titem,index) =>{
            if(titem == sitem){
              if(index == that.mingdanTargetKeys.length-1 ){
                //最后个
                return;
              }
              var temp = list[index];
//              that.$set(this.mingdanTargetKeys,index,that.mingdanTargetKeys[index-1]);
//              that.$set(this.mingdanTargetKeys,index-1,temp);

              list[index] = list[index+1];
              list[index+1] = temp;

            }
          })

        });

        that.mingdanTargetKeys = [...list];
      },
      mingdanHandleSelectChange(sourceSelectedKeys, targetSelectedKeys) {
        this.selectedMingdanKeys = [...targetSelectedKeys];
        console.log('sourceSelectedKeys: ', sourceSelectedKeys);
        console.log('targetSelectedKeys: ', targetSelectedKeys);
      },
      mingdanFilterOption(inputValue, option) {
        return option.title.indexOf(inputValue) > -1;
      },
      mingdanHandleChange(targetKeys, direction, moveKeys) {
        console.log(targetKeys, direction, moveKeys);
        this.mingdanTargetKeys = targetKeys;
      },
      mingdanHandleSearch(dir, value) {
        console.log('search:', dir, value);
      },

      fetchMingdanList(){
        let self = this
        getKaojiYundongyuanList({
          'exame_id' : self.exame_id
        }).then(res => {
          self.mingdanList = res.data.list;
          self.mingdanTargetKeys = res.data.selectKeys;
        })
      },

      //
      handleMingdanManage(record) {
        let self = this
        self.exame_id = record.id;
        self.fetchMingdanList();
        this.mingdanVisible = true
      },
      mingdanSave(){
        let that = this;
        let selectList = [];
        that.mingdanTargetKeys.map(key => {
          that.mingdanList.map(item =>{
            if(item.key == key ){
              selectList.push(item);
              return ;
            }
          })
        })

        if(selectList.length==0){
          that.$message.error('请至少选择一位运动员');
          return ;
        }

        console.log(selectList);
//        return ;

        mingdanSave({
          exame_id : that.exame_id,
          list:JSON.stringify(selectList)
        }).then(res => {
          that.$message.success('保存成功');
          that.$refs.table.refresh()
        }).catch(err =>{
          that.$message.error(err.data.msg);
        })
        this.mingdanVisible = false;
      },
      //
      handleStep1Manage(record) {
        let self = this
        self.exame_id = record.id;
        self.userQuery.exame_id = record.id;
        self.userQuery.keywords = undefined;
        self.fetchStep1List();
        this.scoreStep1Visible = true
      },

      handleStep2Manage(record) {
        let self = this
        self.exame_id = record.id;
        self.userQuery.exame_id = record.id;
        self.fetchStep2List();
      },

      fetchStep1List(){
        let self = this
        getScore1List({
          'exame_id' : self.exame_id
        }).then(res => {
          self.scoreList1 = res.data;
        })
      },
      setAllScorePeixun(){
        let that = this;
        this.scoreList1.list.map(item => {
          item.score_peixun =that.allScorePeixun;
        })
      },
      setAllScoreGongyi(){
        let that = this;
        this.scoreList1.list.map(item => {
          item.score_gongyi =that.allScoreGongyi;
        })
      },
      score1Save(){
        let that = this;
        if(that.scoreList1.exame.kaoguan.length<2){
          that.$message.error('至少2个考官');
          return ;
        }
        if(that.scoreList1.exame.jiandu.length<1){
          that.$message.error('至少1个监督');
          return ;
        }
        score1Save({
          exame_id : that.exame_id,
          exame : that.scoreList1.exame,
          list:JSON.stringify(that.scoreList1.list)
        }).then(res => {
          that.$message.success('保存成功')
          that.$refs.table.refresh();
        }).catch(err =>{
          that.$message.error(err.data.msg);
        })
        this.scoreStep1Visible = false;
      },
      addKaoguan(){
        if(this.scoreList2.exame.kaoguan.length<4){
          this.scoreList2.exame.kaoguan.push('');
        }
      },
      removeKaoguan(){
        this.scoreList2.exame.kaoguan.pop();
        let index = this.scoreList2.exame.kaoguan.length;
        this.scoreList2.list.map((item) =>{
          item['score_fanteng'+(index+1)] = 0;
          item['score_zhuanti'+(index+1)] = 0;
          item['score_tiaoyue'+(index+1)] = 0;
          item['score_pingheng'+(index+1)] = 0;
          item['score_liliang'+(index+1)] = 0;
          item['score_dongzuo'+(index+1)] = 0;
        })

      },
      columnsCompute(){
        this.step2Columns = [
          {
            title: '运动员姓名',
            dataIndex: 'name',
            width: 200,
            fixed: 'left',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '翻腾',
            width: 150,
            dataIndex: 'score_fanteng1',
            scopedSlots: { customRender: 'score_fanteng' },
          },
          {
            title: '转体',
            width: 150,
            dataIndex: 'score_zhuanti1',
            scopedSlots: { customRender: 'score_zhuanti' },
          },
          {
            title: '跳跃',
            width: 150,
            dataIndex: 'score_tiaoyue1',
            scopedSlots: { customRender: 'score_tiaoyue' },
          },
          {
            title: '平衡柔韧',
            width: 150,
            dataIndex: 'score_pingheng1',
            scopedSlots: { customRender: 'score_pingheng' },
          },
          {
            title: '力量素质',
            width: 150,
            dataIndex: 'score_liliang1',
            scopedSlots: { customRender: 'score_liliang' },
          },
          {
            title: '动作组合',
            width: 150,
            dataIndex: 'score_dongzuo1',
            scopedSlots: { customRender: 'score_dongzuo' },
          },
          {
            width: 100,
            fixed: 'right',
            title: '总分',
            dataIndex: 'score_total',
          },
          {
            fixed: 'right',
            title: '缓考',
            dataIndex: 'huankao',
            scopedSlots: {
              customRender: 'huankao',
            }
          }
        ];
      },
      scoreCompute(){
        let that = this
        that.scoreList2.list.map(item =>{
          let score_total = 0;
          score_total += parseInt((item.score_sai>0?item.score_sai:0)*10);
          score_total += parseInt((item.score_peixun>0?item.score_peixun:0)*10);
          score_total += parseInt((item.score_gongyi>0?item.score_gongyi:0)*10);


          let score_fanteng =0;
          let score_zhuanti =0;
          let score_tiaoyue =0;
          let score_pingheng =0;
          let score_liliang =0;
          let score_dongzuo =0;

          let score_fanteng_kaoguan =0;
          let score_zhuanti_kaoguan =0;
          let score_tiaoyue_kaoguan =0;
          let score_pingheng_kaoguan =0;
          let score_liliang_kaoguan =0;
          let score_dongzuo_kaoguan =0;

          that.scoreList2.exame.kaoguan.map((kaoguan,index) =>{
//            if(item['score_fanteng'+(index+1)]>0){
              score_fanteng += parseInt(item['score_fanteng'+(index+1)])*10;
              score_fanteng_kaoguan ++;
//            }
//            if(item['score_zhuanti'+(index+1)]>0){
              score_zhuanti += parseInt(item['score_zhuanti'+(index+1)])*10;
              score_zhuanti_kaoguan ++;
//            }
//            if(item['score_tiaoyue'+(index+1)]>0){
              score_tiaoyue += parseInt(item['score_tiaoyue'+(index+1)])*10;
              score_tiaoyue_kaoguan ++;
//            }
//            if(item['score_pingheng'+(index+1)]>0){
              score_pingheng += parseInt(item['score_pingheng'+(index+1)])*10;
              score_pingheng_kaoguan ++;
//            }
//            if(item['score_liliang'+(index+1)]>0){
              score_liliang += parseInt(item['score_liliang'+(index+1)])*10;
              score_liliang_kaoguan ++;
//            }
//            if(item['score_dongzuo'+(index+1)]>0){
              score_dongzuo += parseInt(item['score_dongzuo'+(index+1)])*10;
              score_dongzuo_kaoguan ++;
//            }


          });

          item.score_fanteng=score_fanteng = score_fanteng_kaoguan>0?parseInt(score_fanteng/score_fanteng_kaoguan):0;
          item.score_zhuanti=score_zhuanti = score_zhuanti_kaoguan>0?parseInt(score_zhuanti/score_zhuanti_kaoguan):0;
          item.score_tiaoyue=score_tiaoyue = score_tiaoyue_kaoguan>0?parseInt(score_tiaoyue/score_tiaoyue_kaoguan):0;
          item.score_pingheng=score_pingheng = score_pingheng_kaoguan>0?parseInt(score_pingheng/score_pingheng_kaoguan):0;
          item.score_liliang=score_liliang = score_liliang_kaoguan>0?parseInt(score_liliang/score_liliang_kaoguan):0;
          item.score_dongzuo=score_dongzuo = score_dongzuo_kaoguan>0?parseInt(score_dongzuo/score_dongzuo_kaoguan):0;
        // console.log('item.score_dongzuo',item.score_dongzuo);
        // console.log('item.score_fanteng',item.score_fanteng);
        // console.log('item.score_zhuanti',item.score_zhuanti);
        // console.log('item.score_tiaoyue',item.score_tiaoyue);
        // console.log('item.score_pingheng',item.score_pingheng);
        // console.log('item.score_liliang',item.score_liliang);

          score_total +=  score_fanteng+score_zhuanti+score_tiaoyue+score_pingheng+score_liliang+score_dongzuo;
//                  parseInt((score_fanteng>0?score_fanteng:0)*10)
//                    +parseInt((score_zhuanti>0?score_zhuanti:0)*10)
//                    +parseInt((score_tiaoyue>0?score_tiaoyue:0)*10)
//                    +parseInt((score_pingheng>0?score_pingheng:0)*10)
//                    +parseInt((score_liliang>0?score_liliang:0)*10)
//                    +parseInt((score_dongzuo>0?score_dongzuo:0)*10)

//          score_total = parseFloat(item.score_sai) + parseFloat(item.score_peixun) + parseFloat(item.score_gongyi);// +parseFloat(score_fanteng);
          item.score_total = score_total/10;
        });
      },
      fetchStep2List(){
        let self = this
        self.saveLoading = true;
        this.$message.loading('加载中...', 0);
        getScore2List({
          'exame_id' : self.exame_id
        }).then(res => {
          self.scoreList2 = res.data;
          self.saveLoading = false;
          this.scoreStep2Visible = true
          this.$message.destroy()
        })
      },
      setScoreStatus(status) {
        let self = this
        editApplyScoreStatus({
          id : self.exame_id,
          score_status: status
        }).then(res => {
          self.$message.success('修改成功')
          self.scoreList2.apply.score_status = 4
          self.saveLoading = false;
        })
      },
      resultConfirm(){
        let that = this;
        window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-28/1627457432493511.xlsx')
        return
        scoreConfirm({
          exame_id : that.exame_id,
        }).then(res => {
          that.$message.success('保存成功')
          this.saveLoading = false;
          this.scoreStep2Visible = false;
          self.$refs.table.refresh();
        }).catch(err =>{
          that.$message.error(err.data.msg);
          this.saveLoading = false;
        })
      },
      score2Save(){
        let that = this;
        let error = false;
        let error_msg = false;
        this.saveLoading = true;
        that.scoreList2.exame.kaoguan.map(item =>{
          if(!item){
            error = true;
            error_msg = '请完善考官信息';
            this.saveLoading = false;
            return ;
          }
        })
        that.scoreList2.exame.jiandu.map(item =>{
          if(!item){
            error = true;
            error_msg = '请完善监督信息';
            this.saveLoading = false;
            return ;
          }
        })
        if(error){
          that.$message.error(error_msg);
          return;
        }
        score2Save({
          exame_id : that.exame_id,
          exame : that.scoreList2.exame,
          list:JSON.stringify(that.scoreList2.list)
        }).then(res => {
          that.$message.success('保存成功')
          this.saveLoading = false;
        }).catch(err =>{
          that.$message.error(err.data.msg);
          this.saveLoading = false;
        })
      },


      kaoguanRemove(index){
        console.log('kaoguanRemove',index);
        this.scoreList1.exame.kaoguan.splice(index,1);
        this.kaoguanPickerShow = false;
      },
      onKaoguanAdd(value){
        console.log('onKaoguanAdd',value);
        let exist = this.scoreList1.exame.kaoguan.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.kaoguanPickerShow = false;
          return ;
        }
        this.scoreList1.exame.kaoguan.push(value);
        this.kaoguanPickerShow = false;
      },
      jianduRemove(index){
        console.log('jianduRemove',index);
        this.scoreList1.exame.jiandu.splice(index,1);
        this.jianduPickerShow = false;
      },
      onJianduAdd(value){
        console.log('onJianduAdd',value);
        let exist = this.scoreList1.exame.jiandu.filter(item =>{
          return item.num == value.num
        });
        if(exist.length >0){
          this.jianduPickerShow = false;
          return ;
        }
        this.scoreList1.exame.jiandu.push(value);
        this.jianduPickerShow = false;
      },

      downloadCert(record){
        window.open(setting.apiBaseURL+'/adminapi/kaojiexame/downloadCert?id='+record.id );
      },

      downloadCertP(record){
        window.open(setting.apiBaseURL+'/adminapi/kaojiexame/downloadCertP?id='+record.id );
      },
      downloadCertSP(){
        window.open(setting.apiBaseURL+ this.scoreList2.exame.cert_zip+'?_m='+Math.random() );
      },

      downloadResults(id){
        window.open(setting.apiBaseURL+'/adminapi/kaojiexame/downloadResults?id='+id );
      },
      onShare(){
        let that = this
        that.h5ShareVisible = true
        that.share.h5_pic_url = this.scoreList2.h5_pic_url
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      toggleAdvanced () {
        this.advanced = !this.advanced
      },

      resetSearchForm () {
        this.queryParam = {
          date: moment(new Date())
        }
      },

        createAllCert(){
          let that = this;
            getAllCertUrls({
                exame_id : that.exame_id,
            }).then(res => {
                that.taskInfo ={
                    urls: res.data,
                    currentIndex:0,
                    scount:0,
                    fcount:0,
                    doing:true,
                }
                that.doTask(that.taskInfo);

            }).catch(err =>{
                that.$message.error(err.data.msg);
            })
        },

        doTask(taskInfo){
            let that = this;
            if(taskInfo.currentIndex >= taskInfo.urls.length){
                taskInfo.doing = false;
                return false;
            }
            doUrlTask({
                url : taskInfo.urls[taskInfo.currentIndex]
            }).then(res => {
                taskInfo.scount++;
                taskInfo.currentIndex++;
                console.log(taskInfo.currentIndex);
                if(taskInfo.currentIndex == (taskInfo.urls.length)){
                    that.scoreList2.exame.cert_zip = res.data;
                }
                taskInfo.percent = (((taskInfo.currentIndex)/taskInfo.urls.length)*100).toFixed(1);
                that.doTask(taskInfo)
            }).catch(err =>{
                taskInfo.fcount++;
                taskInfo.currentIndex++;
                taskInfo.percent = (((taskInfo.currentIndex)/taskInfo.urls.length)*100).toFixed(1);
                that.doTask(taskInfo)
            });
        }
        ,onCertFaceChange(value){
          let that = this;
          console.log('onCertFaceChange',value);
          setCertFace({
            exame_id : that.exame_id,
            cert_with_face : value,
          }).then(res => {
          }).catch(err =>{
            that.$message.error(err.data.msg);
          })
      },




      readFile(evt) {
        console.log('------readFile------', evt)
        var that = this;
        that.errorMsg = []
        that.index = 0

        that.showTemplate = false

        let files = {0: evt.file}

        const fileReader = new FileReader();
        fileReader.onload = (ev) => {
          try {
            const data = ev.target.result;
            const workbook = XLSX.read(data, {
              type: 'binary'
            });
            const wsname = workbook.SheetNames[0];//取第一张表
            var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

            console.log(list)
            // if (that.startNum) {
            //   list = list.splice(that.startNum, list.length)
            // }

            that.listData = list
            // let listData = list.filter(row => {
            //   return row.hasOwnProperty("__EMPTY");
            // })
            console.log('onGetData', list)
            // return
            that.formatData()

          } catch (e) {
            console.log(e)
            return false;
          }
        };
        fileReader.readAsBinaryString(files[0]);
      },

      formatData() {
        let that = this
        that.showLoading = true
        that.listData.map((row) => {
          that.addRow(row)
        })
      },

      addRow(row) {
        let that = this
        let memberRow = {
          exame_id: 0,
          baoming_member_id: 0,
          name: '',
          num: '',
          grade: '',
          huankao: 2,
          score_sai: 0,
          score_peixun: 0,
          score_gongyi: 0,
          score_dongzuo1: 0,
          score_dongzuo2: 0,
          score_dongzuo3: 0,
          score_dongzuo4: 0,
          score_pingheng1: 0,
          score_pingheng2: 0,
          score_pingheng3: 0,
          score_pingheng4: 0,
          score_liliang1: 0,
          score_liliang2: 0,
          score_liliang3: 0,
          score_liliang4: 0,
          score_fanteng1: 0,
          score_fanteng2: 0,
          score_fanteng3: 0,
          score_fanteng4: 0,
          score_zhuanti1: 0,
          score_zhuanti2: 0,
          score_zhuanti3: 0,
          score_zhuanti4: 0,
          score_tiaoyue1: 0,
          score_tiaoyue2: 0,
          score_tiaoyue3: 0,
          score_tiaoyue4: 0,
          score_total: 0,
        }
        memberRow.name = row['姓名']
        memberRow.num = row['身份证号']
        memberRow.grade = row['考试星级（红/橙/黄/绿/青/蓝/紫）']
        memberRow.huankao = row['是否缓考（是/否）'] == '是' ? 1 : 2
        memberRow.score_sai = row['赛事']
        memberRow.score_peixun = row['培训课时']
        memberRow.score_gongyi = row['品德']
        memberRow.score_dongzuo1 = row['动作组合1']
        memberRow.score_dongzuo2 = row['动作组合2']
        memberRow.score_dongzuo3 = row['动作组合3']
        memberRow.score_dongzuo4 = row['动作组合4']
        memberRow.score_pingheng1 = row['平衡柔韧1']
        memberRow.score_pingheng2 = row['平衡柔韧2']
        memberRow.score_pingheng3 = row['平衡柔韧3']
        memberRow.score_pingheng4 = row['平衡柔韧4']
        memberRow.score_liliang1 = row['力量素质1']
        memberRow.score_liliang2 = row['力量素质2']
        memberRow.score_liliang3 = row['力量素质3']
        memberRow.score_liliang4 = row['力量素质4']
        memberRow.score_fanteng1 = row['翻腾1']
        memberRow.score_fanteng2 = row['翻腾2']
        memberRow.score_fanteng3 = row['翻腾3']
        memberRow.score_fanteng4 = row['翻腾4']
        memberRow.score_zhuanti1 = row['转体1']
        memberRow.score_zhuanti2 = row['转体2']
        memberRow.score_zhuanti3 = row['转体3']
        memberRow.score_zhuanti4 = row['转体4']
        memberRow.score_tiaoyue1 = row['跳跃1']
        memberRow.score_tiaoyue2 = row['跳跃2']
        memberRow.score_tiaoyue3 = row['跳跃3']
        memberRow.score_tiaoyue4 = row['跳跃4']
        memberRow.score_total = row['总分']
        memberRow.exame_id = that.exame_id
        console.log(memberRow)
        // return
        that.kaojiMemberAdd(memberRow)
      },

      kaojiMemberAdd(memberRow) {
        let that = this

        // return
        scoreMemberAdd(memberRow).then(res => {
          if (res[600]) {
            that.errorMsg.push(res[600])
          }
          that.getProgress()
        }).catch(err =>{
          console.log(err)
          if (err.code === 600) {
            that.errorMsg.push(err.msg)
          }
          that.getProgress()
        })
      },

      getProgress() {
        let that = this
        that.index += 1

        let index = that.index,
            list = that.listData

        // console.log(that.errorMsg, index, list.length)

        that.progress = parseInt((index / list.length) * 100);
        if (index === list.length) {
          that.showLoading = false
          that.fetchStep2List()

          if (that.errorMsg.length > 0) {
            // 唤起弹框
            that.showError = true
          } else {
            that.$message.success('批量导入成功')
          }
        }
      },

    },
  }
</script>

<style scoped>
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
  .ant-transfer .ant-transfer-list:first-child .footer-btn{display: none}
</style>
